import * as l from './BodyWeight.loc.js';
import { defineMeasurement } from './ScalarMeasurement.js';
/**
 * Patient-reported body weight. Stored canonically in kilograms (LOINC 29463-7); offered in kg and lb.
 * Factors are relative to a grams base, so lb → kg normalizes as `value * 453.592 / 1000`.
 */
export const BodyWeight = defineMeasurement({
    units: {
        /** Kilograms (canonical). */
        kg: 1000,
        /** Pounds. */
        lb: 453.592,
    },
    canonical: 'kg',
    label: l.label,
    unitLabel: l.unitLabel,
    loinc: '29463-7',
    step: 0.1,
    min: 1,
});
//# sourceMappingURL=BodyWeight.js.map